import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { useSelector } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PuffLoader from 'react-spinners/PuffLoader';
import Nav from "./Nav";
import { css } from "@emotion/react";

import 'react-tabs/style/react-tabs.css';
import { If, Then, Else } from 'react-if';
import { comma } from './Func.js';

const override = css`
    display: block;
    margin: auto;
    margin-top: 50px;
    border-color: red;
`;
const History = () => {
    const address = useSelector((state) => state.address.value);
    const [pointHistory, setPointHistory] = useState('');
    const [cretaHistory, setCretaHistory] = useState('');
    const [withdrawHistory, setWithdrawHistory] = useState('');    
    const [depositHistory, setDepositHistory] = useState('');
    
    const [pointHistoryLoading, setPointHistoryLoading] = useState(true);
    const [cretaHistoryLoading, setCretaHistoryLoading] = useState(true);
    const [withdrawHistoryLoading, setWithdrawHistoryLoading] = useState(true);
    const [depositHistoryLoading, setDepositHistoryLoading] = useState(true);
    
    const [limit1, setLimit1] = useState(30);
    const [limit2, setLimit2] = useState(30);
    const [limit3, setLimit3] = useState(30);
    const [limit4, setLimit4] = useState(30);

    const getPointHistory = useCallback(async () => {      
        setPointHistoryLoading(true);
        axios.post('api/getPointHistory', {
            address: address,
            limit: limit1,
        })
        .then((res) => {
            setPointHistory(res.data);
            setPointHistoryLoading(false);
        })
        .catch((err) => {
            setPointHistoryLoading(false);
            if(err.response){
                console.log(err.response);
            }
        })
    }, [setPointHistoryLoading, setPointHistory, address, limit1]);

    const getCretaHistory = useCallback(async () => {      
        setCretaHistoryLoading(true);
        axios.post('api/getCretaHistory',{
            address: address,
            limit: limit2
        })
        .then((res) => {
            setCretaHistory(res.data);
            setCretaHistoryLoading(false);
        })
        .catch((err) => {
            setCretaHistoryLoading(false);
            if(err.response){
                console.log(err.response);
            }
        })
    }, [setCretaHistoryLoading, setCretaHistory, address, limit2]);

    const getWithdrawHistory = useCallback(async () => {  
        setWithdrawHistoryLoading(true);
        axios.post('api/getWithdrawHistory', {
            address: address,
            limit: limit3,
        })
        .then((res) => {
            setWithdrawHistory(res.data);
            setWithdrawHistoryLoading(false);
        })
        .catch((err) => {
            setWithdrawHistoryLoading(false);
            if(err.response){
                console.log(err.response);
            }
        })
    }, [setWithdrawHistoryLoading, setWithdrawHistory, address, limit3]);

    const getDepositHistory = useCallback(async () => {      
        setDepositHistoryLoading(true);
        axios.post('api/getDepositHistory', {
            address: address,
            limit: limit4,
        })
        .then((res) => {
            setDepositHistory(res.data);
            setDepositHistoryLoading(false);
        })
        .catch((err) => {
            setDepositHistoryLoading(false);
            if(err.response){
                console.log(err.response);
            }
        })
    }, [setDepositHistoryLoading, setDepositHistory, address, limit4]);


    useEffect(() => {
        getPointHistory();
    }, [limit1, getPointHistory])

    useEffect(() => {
        getCretaHistory();    
    }, [limit2, getCretaHistory])

    useEffect(() => {
        getWithdrawHistory();
    }, [limit3, getWithdrawHistory])

    useEffect(() => {
        getDepositHistory();
    }, [limit4, getDepositHistory])

    function Loading(){              
        return(<PuffLoader color="#fff" loading={true} css={override} size={100} />)
    }    

    function splitText(type, text){
        if(type === 'USDT'){
            let addrLength = text.split('').length;
            return text.substring(0, 5)+'.....'+text.substring(addrLength-5);
        }else if(type === 'CARD'){            
            return text.substring(0, 8)+'...';
        }else if(type === 'CRETA'){            
            return '';
        }else{
            return text;
        }
    }

    const setStatus = (status) => {
        switch (status) {
            case 0:
                return 'Waiting'
            case 1:
                return 'Approval'
            case 2:
                return 'Completed'
            case 3:
                return 'Failure'
            case 4:
                return 'Rejected'
            default:
                return '-'
        }
    }


    function PointHistory(){
        return (
            <div className="receive-history history-wrap">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pointRows(pointHistory)}
                    </tbody>
                </table>
                {
                    pointHistoryLoading ? <Loading></Loading> 
                    : 
                    pointHistory.length < limit1? <div className="view-info">{pointHistory.length===0?'No data':'End of list'}</div>                                        
                    :<button className="btn view-more" onClick={() => setLimit1(limit1 + 30)}>More ...</button>
                }
            </div>
        )
    }

    const pointRows = (rows) => {
        if(rows !== ''){
            return rows.map((row, idx) => 
                <tr key={idx}>
                    <td width={'30%'}>{row.date}</td>
                    <td width={'30%'}>{row.type}</td>
                    <td width={'30%'}>{comma(row.amount)}</td>
                </tr>
            )
        } else {
            return ""
        }
    }

   
    function CretaHistory(){
        return (
            <div className="receive-history history-wrap">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>                            
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cretaHistoryRows(cretaHistory)}
                    </tbody>
                </table>
                <If condition={cretaHistoryLoading}>
                    <Then>
                        <Loading></Loading> 
                    </Then>
                    <Else>
                        <If condition={cretaHistory.length < limit2}>
                            <Then>
                                <div className="view-info">{cretaHistory.length===0?'No data':'End of list'}</div>    
                            </Then>
                            <Else>
                                <button className="btn view-more" onClick={() => setLimit2(limit2 + 30)}>More ...</button>
                            </Else>
                        </If>
                    </Else>
                </If>               
            </div>
        )
    }

    const cretaHistoryRows = (rows) => {
        console.log(rows);
        if(rows !== ''){
            return rows.map((row, idx) => 
                <tr key={idx}>
                    <td width={'30%'}>{row.created_at}</td>
                    <td width={'30%'}>{row.reason}</td>
                    <td width={'30%'}>{comma(row.amount)}</td>
                </tr>
            )
        } else {
            return ""
        }
    }

    function WithdrawHistory(){
        return (
            <div className="receive-history history-wrap">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {withdrawRows(withdrawHistory)}
                    </tbody>
                </table>
                {
                    withdrawHistoryLoading ? <Loading></Loading> 
                    : 
                    withdrawHistory.length < limit3? <div className="view-info">{withdrawHistory.length===0?'No data':'End of list'}</div>                                        
                    :<button className="btn view-more" onClick={() => setLimit3(limit3 + 30)}>More ...</button>
                }
            </div>
        )
    }

    const withdrawRows = (rows) => {
        console.log(rows);
        if(rows !== ''){
            return rows.map((row, idx) => 
                <tr key={idx}>
                    <td width={'25%'}>{row.created_at}</td>
                    <td width={'30%'}>{row.type}</td>
                    <td width={'20%'}>{comma(row.amount)}</td>
                    <td width={'25%'}>{setStatus(row.status)}</td>
                </tr>
            )
        } else {
            return ""
        }
    }

    function DepositHistory(){
        return (
            <div className="deposit-history history-wrap">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Info</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {depositRows(depositHistory)}
                    </tbody>
                </table>
                {
                    depositHistoryLoading ? <Loading></Loading> 
                    : 
                    depositHistory.length < limit4? <div className="view-info">{depositHistory.length===0?'No data':'End of list'}</div>                                        
                    :<button className="btn view-more" onClick={() => setLimit4(limit4 + 30)}>More ...</button>
                }
            </div>
        )
    }

    const depositRows = (rows) => {
        if(rows !== ''){
            return rows.map((row, idx) => 
                <tr key={idx}>
                    <td width={'25%'}>{row.date}</td>
                    <td width={'20%'}>{row.type}</td>
                    <td width={'25%'}>{splitText(row.type, row.txid)}</td>
                    <td width={'30%'}>+{comma(row.amount)} USDT</td>
                </tr>
            )
        } else {
            return (
                <tr>
                    <td colSpan="3">Data is empty!</td>
                </tr>
            )
        }
    }    
    
    return (
        <div className="sub-container">
            <div id="history" className="content">
                <p className="hisTitle" style={{marginLeft: 15}}>History</p>
                <Tabs>
                    <TabList>
                        <Tab>Commission</Tab>
                        <Tab>CRETA</Tab>
                        <Tab>Withdraw</Tab>                        
                        <Tab>Invest</Tab>
                    </TabList>
                    <TabPanel><PointHistory /></TabPanel>
                    <TabPanel><CretaHistory /></TabPanel>                                        
                    <TabPanel><WithdrawHistory /></TabPanel>
                    <TabPanel><DepositHistory /></TabPanel>
                </Tabs>
            </div>
            <Nav/>
        </div>
    )
    
}

export default History;